/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NavigationModule
 */

import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';

import { IAppState } from 'ajs/js/services/appStates.types';
import { INavState } from '../../navigation.types';
import './vertical-nav.component.less';

/**
 * @desc
 *     Vertical Nav component that renders a list of states. Shows/hides states based on permissions
 *     and shows active states and expands parent states where applicable.
 * @author alextsg
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'vertical-nav',
    templateUrl: './vertical-nav.component.html',
})
export class VerticalNavComponent {
    @Input()
    public states: INavState[];

    /**
     * Passed to clrVerticalNavCollapsed as two-way binding to indicate if the vertical nav is
     * collapsed. This property does not have a default value as its value is controlled only by
     * clrVerticalNavCollapsed.
     */
    public collapsed: boolean;

    /**
     * Track by function for ngFor iterator on states.
     */
    public trackByState(index: number, state: IAppState): string {
        return state.name;
    }
}
